/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import { AssetQualityLevel, IResourcesGroupConfig } from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { TextureAsset } from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import { BitmapFontAsset } from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import { SpineAsset } from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class BarbarianFuryGameAssets {
    public static MAIN_GAME_REEL_FRAME: string = "mainGameReelFrame";
    public static BONUS_GAME_REEL_FRAME: string = "bonusGameReelFrame";

    public static MAIN_GAME_REEL_CHAIN: string = "mainGameReelChainLeft";
    public static BONUS_GAME_REEL_CHAIN: string = "bonusGameReelChainLeft";
    public static BONUS_GAME_MOON_BG: string = "bonusGameMoonBG";

    public static REEL_BG_MAIN_GAME: string = "mainGameReelBg";
    public static REEL_BG_BONUS_GAME: string = "bonusGameReelBg";

    public static BONUS_GAME_STONE_FOREGROUND: string = "bonusGameStoneForeground";


    public static GAME_INTRO_BANNER: string = "introBanner";

    public static VOLATILITY_HIGH: string = "introVolatilityHigh";
    public static X_NUDGE: string = "introXNudge";

    public static MAIN_GAME_STONE_FOREGROUND: string = "resources/images/introStones.png";
    public static MAIN_GAME_BACKGROUND = "resources/images/mainBackground.jpg";
    public static INTRO_BORDER: string = "resources/images/introBorder.png";
    public static INTRO_LOGO: string = "resources/images/introLogo.png";
    public static GAME_INTRO_RESPIN: string = "resources/images/introRespin.png";
    public static GAME_INTRO_SCATTERS: string = "resources/images/introScatters.png";
    public static GAME_INTRO_WILD: string = "resources/images/introWild.png";
    public static WIN_AMOUNT_SHADOW:string = "resources/images/WinAmountShadow.png";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("NumbersHotNudge", "fonts/bitmapfonts/NumbersHotNudge.fnt"),
                    new BitmapFontAsset("BigMultiplier", "fonts/bitmapfonts/BigMultiplier.fnt"),
                    new BitmapFontAsset("OutroText", "fonts/bitmapfonts/OutroText.fnt")
                ]
            }
        ],

        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                ],
                animations: {
                    "bonusGameStoneForeground": "foreground/bonusGameStoneForeground",
                    "bonusGameReelChainLeft": "reelFrame/chain_left_FS",
                    "mainGameReelChainLeft": "reelFrame/chain_left_MG",
                    "mult_fr_x": "reelFrame/frameMultiplier/x",
                    "mult_fr_0": "reelFrame/frameMultiplier/0",
                    "mult_fr_1": "reelFrame/frameMultiplier/1",
                    "mult_fr_2": "reelFrame/frameMultiplier/2",
                    "mult_fr_3": "reelFrame/frameMultiplier/3",
                    "mult_fr_4": "reelFrame/frameMultiplier/4",
                    "mult_fr_5": "reelFrame/frameMultiplier/5",
                    "mult_fr_6": "reelFrame/frameMultiplier/6",
                    "mult_fr_7": "reelFrame/frameMultiplier/7",
                    "mult_fr_8": "reelFrame/frameMultiplier/8",
                    "mult_fr_9": "reelFrame/frameMultiplier/9",
                    "bonusGameMoonBG": "reelFrame/moon_FS",
                    "bonusGameMultiplierBg": "reelFrame/multiplier_holder_FS",
                    "mainGameMultiplierBg": "reelFrame/multiplier_holder_MG",
                    "bonusGameReelFrame": "reelFrame/reel_frame_FS",
                    "mainGameReelFrame": "reelFrame/reel_frame_MG",
                    "bigWinCoin0": "bigWin/bronze_Coin/",
                    "bigWinCoin1": "bigWin/silver_Coin/",
                    "bigWinCoin2": "bigWin/Gold_Coin/",
                    "midSymAddFreezeAnim": "midSymAddFreezeAnim/F01_",
                    "midSymRemoveFreezeAnim": "midSymRemoveFreezeAnim/F01_",
                    "multiplierUpFrame": "multiplierHolder/highlightedFrame"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json")
                ],
                animations: {
                    "fs_intro_splash_bg": "fs_intro_splash_bg",
                    "snowFall": "snow_fall/RBF/RBF_",
                    "BetLineBoxAnimation": "betLineBox/BetLineBox_",
                    "symMultiplier": "multiplierHolder/symMultiplier/symMultiplier_",
                    "innerFire": "multiplierHolder/innerFire/innerFire_",
                    "multiplierBlast": "multiplierHolder/multiplierBlast/mb_",
                    "bonusGameReelBg": "reelFrame/reel_background_FS",
                    "mainGameReelBg": "reelFrame/reel_background_MG",
                    "Betline0": "Betline/Betline_00000",
                    "Betline1": "Betline/Betline_00001",
                    "Betline2": "Betline/Betline_00002",
                    "Betline3": "Betline/Betline_00003",
                    "Betline4": "Betline/Betline_00004",
                    "anticipationAnim": "anticipation/anticipation_",
                    "TeaseAnimation": "Tease Animation/Tease Animation_",
                    "Re_spin_Anticipation": "Re-spin-Anticipation/Re-spin-Anticipation_",
                    "midSymAddSmokeAnim": "midSymAddFreezeSmokeAnim/smoke_",
                    "bigWinFire": "bigWin/fire/barbaric_00000/barbaric_00000_",
                    "postTeaseAnimation": "Post Tease Animation/Post Tease Animation_",
                    "reelBottomFire": "reel_bottom_fire/RBF/RBF_",
                    "bigWinParticles": "win_levels/particles/particles_",
                    "smokeFireParticles": "smokeFireParticles/bonus fire partical_"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            },
            {
                name: "symbolsAnimations",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsAnimations0", "sheets/symbolsAnimations/symbolsAnimations0.json"),
                    new TextureAsset("symbolsAnimations1", "sheets/symbolsAnimations/symbolsAnimations1.json"),
                    new TextureAsset("symbolsAnimations2", "sheets/symbolsAnimations/symbolsAnimations2.json")
                ]
            },
            {
                name: "symbolsAnimationsWin",
                assets: [
                    new TextureAsset("symbolsAnimationsWin0", "sheets/symbolsAnimationsWin/symbolsAnimationsWin0.json"),
                    new TextureAsset("symbolsAnimationsWin1", "sheets/symbolsAnimationsWin/symbolsAnimationsWin1.json"),
                    new TextureAsset("symbolsAnimationsWin2", "sheets/symbolsAnimationsWin/symbolsAnimationsWin2.json"),
                    new TextureAsset("symbolsAnimationsWin3", "sheets/symbolsAnimationsWin/symbolsAnimationsWin3.json")
                ],
                animations: {
                    "wildSpinningFire": "W/wild_back_fire/WBF01_",
                    "wildLandingFire": "W/wild_landing/wild_landing_",
                    "scatterSpinningFire": "S/scatter_back_fire/SF01_",
                    "scatterLandingFire": "S/scatter_landing/SLF_"
                }
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ],
                animations: {
                    "fsCounter": "fsCounterBg",
                    "freespinAdd1": "PlusOneFreeSpin",
                    "fs_fury_text": "Intro/fs_fury_text",
                    "fs_m": "Intro/fs_m",
                    "scatter_fs": "Intro/scatter_fs",
                    "fs_intro_wild": "Intro/fs_intro_wild",
                    "FS_Outro_landscape": "Outro/FS_Outro_landscape",
                    "FS_Outro_portrait": "Outro/FS_Outro_portrait",
                    "total_spin": "Outro/total-spin",
                    "total_win": "Outro/total-win",
                    "final_multiplier": "Outro/final-multiplier",
                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("M1_spine", "spines/M1.json"),
                    new SpineAsset("M2_spine", "spines/M2.json"),
                    new SpineAsset("M3_spine", "spines/M3.json"),
                    new SpineAsset("L1_spine", "spines/L1.json"),
                    new SpineAsset("L2_spine", "spines/L2.json"),
                    new SpineAsset("L3_spine", "spines/L3.json"),
                    new SpineAsset("L4_spine", "spines/L4.json"),
                    new SpineAsset("L5_spine", "spines/L5.json"),
                    new SpineAsset("W_spine", "spines/W.json")
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }

        if (stateName === "idle") {
            return symbolName + "/idle_animation/" + symbolName + "_" + stateName + "_";
        }

        if (stateName === "initialWin") {
            return symbolName + "/initialWin_animation/" + symbolName + "_" + stateName + "_";
        }

        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName: string, stateName: string | null = null): PIXI.Texture[] {
        return GameResources.getTextures(BarbarianFuryGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }
}
